import type { NextPage } from 'next';

import { ContentPage } from '@webapp/landing/src/components/content-page';
import type { CmsPage } from '@webapp/landing/src/resources/api';
import { fetchPage } from '@webapp/landing/src/resources/api';
import { filterBlogContent } from '@webapp/landing/src/utils/filters';

const BlogSlug: NextPage<{ content: Array<CmsPage> }> = ({ content }) => {
    return <ContentPage content={filterBlogContent(content)} withMenu={false} canonical='ru/blog' />;
};

export const getServerSideProps = async ({
    params: { name }
}: {
    params: { name: string };
}): Promise<{ props: AnyObject; notFound?: boolean }> => {
    const props = await fetchPage(name);

    return {
        props,
        notFound: props.notFound
    };
};

// eslint-disable-next-line import/no-default-export
export { BlogSlug as default };
